import React from "react";
import withSession from "./withSession";
import { SuperblocksEmbed } from "@superblocksteam/embed-react";

const Reports = (props) => {
  return (
    <div style={{ width: "100vw", height: "100vh", margin: 0, padding: 0 }}>
      {props.session.me.clientName === "lumify" && (
        <SuperblocksEmbed
          //src="https://app.superblocks.com/embed/applications/f901152e-7049-4ba3-9c01-566b8e2c7f30"
          src="https://app.superblocks.com/embed/applications/f3a5c6d0-3301-48f5-b5d1-fa469ff86a20"
          style={{ width: "100%", height: "100%" }} // Ensure the embed takes full size
        />
      )}
      {props.session.me.clientName === "feelwise" && (
        <SuperblocksEmbed
          src="https://app.superblocks.com/embed/applications/d7587edc-4faa-4e64-8e54-d03cac8773f9"
          style={{ width: "100%", height: "100%" }} // Ensure the embed takes full size
        />
      )}
    </div>
  );
};

export default withSession(Reports);
